import { AboutUsElementDataType } from '@/components/sections/builder/elements/body/about-us/type';
import ImageSetting from '@/components/sections/builder/settings/image-setting';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { useBuilderStore } from '@/stores/builder';

export default function ElementSettingAboutUs({ element }: ElementProps) {
  const content = element.data as AboutUsElementDataType;

  const builder = useBuilderStore((state) => ({
    setElementData: state.setElementData,
  }));

  return (
    <div>
      <span className='mb-2 flex text-sm'>Image</span>
      <ImageSetting
        value={content?.image}
        onChange={(val) =>
          builder.setElementData(element.id, {
            image: val,
          })
        }
      />
      <span className='mt-4 flex text-sm'>Color scheme</span>
      <SchemeSetting
        value={content.colorSchemeSection}
        onChange={(val) =>
          builder.setElementData(element.id, {
            colorSchemeSection: val,
          })
        }
      />
      <span className='mt-4 flex text-sm'>Padding</span>
      <InputSlider
        label='Top padding'
        value={content.padding?.top || 0}
        min={0}
        max={200}
        step={1}
        onChange={(val) => {
          builder.setElementData(element.id, {
            padding: {
              ...content.padding,
              top: val,
            },
          });
        }}
      />
      <InputSlider
        label='Bottom padding'
        value={content.padding?.bottom || 0}
        min={0}
        max={200}
        step={1}
        onChange={(val) => {
          builder.setElementData(element.id, {
            padding: {
              ...content.padding,
              bottom: val,
            },
          });
        }}
      />
      <InputSlider
        label='Left padding'
        value={content.padding?.left || 0}
        min={0}
        max={200}
        step={1}
        onChange={(val) => {
          builder.setElementData(element.id, {
            padding: {
              ...content.padding,
              left: val,
            },
          });
        }}
      />
      <InputSlider
        label='Right padding'
        value={content.padding?.right || 0}
        min={0}
        max={200}
        step={1}
        onChange={(val) => {
          builder.setElementData(element.id, {
            padding: {
              ...content.padding,
              right: val,
            },
          });
        }}
      />
    </div>
  );
}
